/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SentenceListResponse = zod
	.array(
		zod
			.object({
				actor_id: zod.string().describe('Actor ID'),
				case_id: zod.string().nullable().describe('Case ID'),
				completed_at: zod.iso
					.datetime({ offset: true })
					.nullable()
					.describe("When the sentence's last directive went terminal"),
				decided_at: zod.iso
					.datetime({ offset: true })
					.nullable()
					.describe('When the sentence was accepted or rejected'),
				decided_by_id: zod
					.string()
					.nullable()
					.describe('ID of the decider (user ID if type is user)'),
				decided_by_type: zod.enum(['system', 'user']),
				directives: zod
					.array(
						zod
							.object({
								case_item_id: zod.string().nullable().describe('Case item ID'),
								directive_id: zod.string().describe('Directive catalog ID'),
								duration_seconds: zod.number().nullable().describe('Duration in seconds'),
								ends_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When this directive expires'),
								id: zod.string().describe('Directive ID'),
								inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
								lifecycle_status: zod.enum(['pending', 'active', 'served', 'revoked', 'voided']),
								policy_plan_component_id: zod
									.string()
									.nullable()
									.describe('Directive component ID'),
								policy_plan_id: zod.string().nullable().describe('Policy plan ID'),
								reasoning: zod.string().nullable().describe('AI reasoning for this directive'),
								require_approval: zod
									.boolean()
									.describe('Whether this directive required approval'),
								revoked_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When this directive was revoked'),
								served_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When this directive was served'),
								starts_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When this directive was activated'),
								updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp'),
								violation_id: zod.string().describe('Violation ID'),
								voided_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When this directive was voided')
							})
							.describe('An individual issued directive within a sentence')
					)
					.describe('Individual issued directives within this sentence'),
				environment_id: zod.string().describe('Environment ID'),
				finalized_at: zod.iso
					.datetime({ offset: true })
					.nullable()
					.describe('When the sentence was finalized'),
				id: zod.string().describe('Sentence ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				organization_id: zod.string().describe('Organization ID'),
				proposed_by_id: zod
					.string()
					.nullable()
					.describe('ID of the proposer (user ID if type is user)'),
				proposed_by_type: zod.enum(['system', 'user']),
				reason: zod.string().nullable().describe('Overall reason for the sentence'),
				status: zod.enum(['proposed', 'accepted', 'rejected', 'completed']),
				trial_confidence: zod
					.number()
					.nullable()
					.describe('Confidence score from the associated trial'),
				trial_id: zod.string().describe('Trial ID'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('A per-trial decision envelope containing multiple directives')
	)
	.describe('List of sentences');

export type SentenceListResponse = zod.input<typeof SentenceListResponse>;
export type SentenceListResponseOutput = zod.output<typeof SentenceListResponse>;
